/**
 * `all[0]` must stay the literal 'promotions' — persistConfig.ts:32 allow-lists
 * dehydration on queryKey[0]. Renaming it silently disables persistence.
 */
export const promotionsKeys = {
  all: ['promotions'] as const,
  list: (storeNumber?: string, storeState?: string) =>
    [...promotionsKeys.all, 'list', storeNumber ?? null, storeState ?? null] as const,
};
